"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupSpeaking = exports.onSpeaking = exports.getConnectedPeers = exports.getStatusMap = exports.getPeerStatusMap = exports.removePeer = exports.kickPeer = exports.connectPeer = exports.updatePeer = exports.addNewPeer = void 0;
const messageBroker_1 = __importDefault(require("general/messageBroker"));
const notifications_1 = require("../utils/notifications");
var lastSpeakingTimeout = 0;
let connected_peers = [];
const uris = {
    "dev": 'http://localhost:9997',
    "prod": 'https://milan.mictap.com',
    "beta": 'https://beta.milan.mictap.com',
};
// Styles
function getStatusMap() {
    return {
        waiting: "text-yellow-500 dark:text-yellow-400", // waiting to be connected
        connected: "text-green-mictap",
        failed: "text-red-500",
        disconnected: "text-red-500 dark:text-red-300",
        kicked: "text-blue-500",
    };
}
exports.getStatusMap = getStatusMap;
function getPeerStatusMap() {
    return {
        waiting: "",
        connected: "",
        failed: "",
        disconnected: "opacity-50",
    };
}
exports.getPeerStatusMap = getPeerStatusMap;
function addNewPeer(peer) {
    // check if peer is in fact newPeer
    let isNew = true;
    connected_peers.forEach((p) => { if (p.public_key == peer.public_key)
        isNew = false; });
    if (!isNew) {
        console.log("New user was not added as it is a dup", peer);
        return connected_peers;
    }
    connected_peers.unshift(peer); // add to the top of the UI
    if (peer.status == "connected") {
        // play a nice sound like a bell
        playConnectedSound();
    }
    // Waiting to be conected
    if (peer.status == "waiting") {
        (0, notifications_1.notify)(peer.name + " (" + peer.role + ") is waiting to join the session", 'Return to host to connect them');
        // play new waiting to be connected sound
        const announcementSoundEl = document.querySelector("#announcementSound");
        if (announcementSoundEl != null)
            announcementSoundEl.play();
    }
    return connected_peers;
}
exports.addNewPeer = addNewPeer;
function updatePeer(peer) {
    for (var i = 0; i < connected_peers.length; i++) {
        if (connected_peers[i].public_key == peer.public_key) {
            connected_peers[i].status = peer.status;
            connected_peers[i].name = peer.name;
            connected_peers[i].role = peer.role;
            if (peer.status == "connected") {
                playReconnectedSound();
            }
            if (peer.status == "disconnected") {
                playDisconnectedSound();
            }
        }
    }
    return connected_peers;
}
exports.updatePeer = updatePeer;
// Kick user from room
function kickPeer(room_key, public_key) {
    // show warning message
    if (confirm("Are you sure you want to remove the user?") == false) {
        return;
    }
    let env = "dev";
    if (!location.host.includes('localhost:3000')) {
        env = "prod";
    }
    // if its in staging the url will always begin with "beta.*"
    if (location.host.includes('beta')) {
        env = "beta";
    }
    let hostname = uris[env];
    // @ts-ignore
    let product = window.product;
    if (product == "mirror_shoot") {
        product = "mirror";
    }
    let action = hostname + `/${product}/rooms/` + room_key + "/disconnect/" + public_key;
    fetch(action, getHeadersFromLocation());
}
exports.kickPeer = kickPeer;
function connectPeer(room_key, public_key) {
    let env = "dev";
    if (!location.host.includes('localhost:3000')) {
        env = "prod";
    }
    // if its in staging the url will always begin with "beta.*"
    if (location.host.includes('beta')) {
        env = "beta";
    }
    let hostname = uris[env];
    // @ts-ignore
    let product = window.product;
    if (product == "mirror_shoot") {
        product = "mirror";
    }
    let action = hostname + `/${product}/rooms/` + room_key + "/connect/" + public_key;
    fetch(action, getHeadersFromLocation());
    return;
}
exports.connectPeer = connectPeer;
function getHeadersFromLocation() {
    // @ts-ignore
    const partKey = window.participant_key;
    const st = localStorage.getItem("mt_st_" + partKey);
    if (st == null) {
        console.error("Error getting Session token for this session", partKey);
        return {};
    }
    return { headers: { 'Authorization': st } };
}
function setupSpeaking(setterFn) {
    // Setup Push To Talk
    messageBroker_1.default.registerNewMessageType('ptt', (data) => {
        // show participant talking
        if (data.message.enabled == false) {
            setterFn({
                isSpeaking: false,
                name: "Nobody is speaking",
                role: "-"
            });
        }
    });
    window.setInterval(() => {
        if (lastSpeakingTimeout < Date.now()) {
            setterFn({
                isSpeaking: false,
                name: "Nobody is speaking",
                role: "-"
            });
        }
    }, 1000);
}
exports.setupSpeaking = setupSpeaking;
function onSpeaking(public_key, setterFn) {
    const peer = connected_peers.filter((peer) => peer.public_key == public_key)[0];
    if (peer == null) {
        console.error("Peer was not found with public key", public_key);
        return;
    }
    setterFn({
        isSpeaking: true,
        name: peer.name,
        role: peer.role,
    });
    lastSpeakingTimeout = Date.now() + 1 * 1000; // timeout in 1 seconds
}
exports.onSpeaking = onSpeaking;
function removePeer(connected_peers, pk) {
    for (var i = 0; i < connected_peers.length; i++) {
        if (connected_peers[i].public_key == pk) {
            connected_peers.splice(i, 1);
        }
    }
    return connected_peers;
}
exports.removePeer = removePeer;
function getConnectedPeers() {
    return connected_peers;
}
exports.getConnectedPeers = getConnectedPeers;
function playConnectedSound() {
    let sound = document.querySelector("#peerConnectedSound");
    if (sound == null)
        return;
    sound.volume = 0.2;
    // play may fail if the user has not interacted with the page yet
    sound.play().catch(() => {
        console.log("Failed to play sound, user has not interacted with the page yet");
    });
}
function playReconnectedSound() {
    let sound = document.querySelector("#peerReconnectedSound");
    if (sound == null)
        return;
    sound.volume = 0.2;
    sound.play().catch(() => {
        console.log("Failed to play sound, user has not interacted with the page yet");
    });
}
function playDisconnectedSound() {
    let sound = document.querySelector("#peerDisconnectedSound");
    if (sound == null)
        return;
    sound.volume = 0.2;
    sound.play().catch(() => {
        console.log("Failed to play sound, user has not interacted with the page yet");
    });
}
